import { render, staticRenderFns } from "./RenderedWysiwygContent.vue?vue&type=template&id=5f6206fa"
import script from "./RenderedWysiwygContent.vue?vue&type=script&lang=ts"
export * from "./RenderedWysiwygContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports